// FormDatePicker component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
import InputMask from 'react-input-mask'

import IntlUtil from '../../../lib/intlutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import DatePicker from '../../common/datepicker/datepicker.jsx'

class FormDatePicker extends Component {
  static get propTypes () {
    return {
      value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string
      ]),
      label: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.string,
      size: PropTypes.string,
      onChange: PropTypes.func,
      required: PropTypes.bool,
      dateFormat: PropTypes.string,
      active: PropTypes.bool,
      hideDatePickerIcon: PropTypes.bool,
      hideInput: PropTypes.bool,
      onValidateDate: PropTypes.func,
      placeholder: PropTypes.string,
      onFocus: PropTypes.func,
      onNavigateMonth: PropTypes.func,
      weekStats: PropTypes.array,
      showWeekNo: PropTypes.bool,
      formatDay: PropTypes.bool,
      showPlaceholder: PropTypes.bool,
      alwaysShowMask: PropTypes.bool,
      errorMsg: PropTypes.string,
      onBlur: PropTypes.func,
      maskChar: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      value: '',
      label: '',
      name: '',
      icon: '',
      size: '',
      onChange: null,
      required: false,
      dateFormat: DateUtil.getDateFormat(),
      active: false,
      hideDatePickerIcon: false,
      hideInput: false,
      onValidateDate: null,
      placeholder: '',
      onFocus: null,
      onNavigateMonth: null,
      weekStats: [],
      showWeekNo: false,
      errorMsg: '',
      showPlaceholder: true,
      alwaysShowMask: false,
      onBlur: null,
      maskChar: null
    }
  }

  constructor (props) {
    super(props)

    const date = props.value ? DateUtil.convert(props.value) : ''
    const valDate = this._convertDateToString(date)
    this.state = {
      error: !!props.errorMsg,
      value: valDate,
      bShowInput: !!valDate
    }

    this.data = {
      weekStats: props.weekStats || [],
      errorMsg: ''
    }

    this._references = {
      datepicker: React.createRef()
    }

    this._bFocus = false
  }

  componentDidMount () {
    if (this.props.active && this._references.datepicker.current) {
      this._references.datepicker.current.openCalendar()
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    let bUpdateState = false
    const stateObj = {}

    if (!_.isEqual(nextProps.weekStats, this.props.weekStats)) {
      this.data.weekStats = nextProps.weekStats || []
      if (this._references.datepicker.current) {
        this._references.datepicker.current.refresh()
      }
    }

    if (this.state.value !== nextProps.value) {
      bUpdateState = true
      stateObj.value = this._convertDateToString(nextProps.value)
    }

    if (this.props.errorMsg !== nextProps.errorMsg) {
      bUpdateState = true
      stateObj.error = !!nextProps.errorMsg
    }

    if (bUpdateState) {
      this.setState(stateObj)
    }
  }

  render () {
    const {
      icon,
      size,
      value,
      dateFormat,
      hideInput,
      formatDay,
      showWeekNo,
      alwaysShowMask
    } = this.props
    const _classNames = classnames(
      'form-datepicker',
      {
        'form-datepicker_hideinput': hideInput
      },
      size ? `form-datepicker_${size}` : null
    )
    const _iconClassName = icon || 'form-calendar'
    const _fieldClassnames = classnames('form-datepicker-field', {
      has_error: this.state.error,
      showinput: this.state.bShowInput
    })
    let valDate = ''
    if (value) {
      valDate = DateUtil.getDisplayPickerDate(new Date(value))
    }

    let showPlaceholder = false
    if (!alwaysShowMask) {
      showPlaceholder = !!(
        (!this.state.value && !this.props.showPlaceholder) ||
        this.props.showPlaceholder
      )
    }

    return (
      <div className={_classNames}>
        <div className={_fieldClassnames}>
          {!this.props.hideDatePickerIcon && (
            <div
              className='input-prefix-icon'
              onClick={this._onShowDatepicker.bind(this)}
            >
              <span className={`icon icon-${_iconClassName} normal`} />
            </div>
          )}
          <DatePicker
            ref={this._references.datepicker}
            onChange={this._handleSelect.bind(this)}
            closeOnSelect
            dateFormat={dateFormat}
            timeFormat={false}
            className='datepicker-input'
            value={valDate}
            inputProps={{
              placeholder: IntlUtil.convertMessage(this.props.placeholder),
              required: this.props.required,
              onFocus: this._onFocusInput.bind(this)
            }}
            isValidDate={this.props.onValidateDate} // eslint-disable-line react/jsx-handler-names
            onNavigateMonth={this._onNavigateMonth.bind(this)}
            renderDay={formatDay ? this._renderDay.bind(this) : null}
            renderWeek={formatDay ? this._renderWeek.bind(this) : null}
            showWeekNo={showWeekNo}
            locale={IntlUtil.getLang()}
            onBlur={this._onBlur.bind(this)}
          />
          {this.state.bShowInput ? (
            <div className='inputedit'>
              <InputMask
                mask={DateUtil.getDisplayInputFormat()}
                autoFocus={this._bFocus}
                placeholder={
                  showPlaceholder
                    ? IntlUtil.convertMessage(this.props.placeholder)
                    : ''
                }
                onFocus={this.props.onFocus}
                required={this.props.required}
                value={this.state.value}
                alwaysShowMask={alwaysShowMask}
                maskChar={this.props.maskChar}
                onChange={this._onChangeInput.bind(this)}
              />
            </div>
          ) : null}
          {!this.props.errorMsg &&
          this.props.label &&
          (!showPlaceholder || this.props.showPlaceholder) ? (
            <span className='input-placeholder-label'>
              <IntlMessage ident={this.props.label} />
            </span>
          ) : (
            this.props.errorMsg && (
              <span className='input-error-label'>
                <IntlMessage ident={this.props.errorMsg} />
              </span>
            )
          )}
        </div>
      </div>
    )
  }

  /* Public Functions */
  showDatePicker () {
    if (this._references.datepicker.current) {
      this._references.datepicker.current.openCalendar()
    }
  }

  focusInput () {
    this._onFocusInput()
  }

  validate () {
    if (!this.props.value) {
      this.setState({ error: true })
      return false
    }

    this.setState({ error: false })
    return true
  }

  showError (bError) {
    this.setState({ error: bError })
  }

  /* Event handlers */
  _convertDateToString (date) {
    if (date) {
      date = new Date(date)
      return `${DateUtil.getDisplayPickerDate(date)}`
    }

    return ''
  }

  _onFocusInput () {
    this.setState({ bShowInput: true })
    this._bFocus = true

    if (this.props.onFocus) {
      this.props.onFocus()
    }

    this.forceUpdate()
  }

  _onBlur (date, ev) {
    if (this.props.onBlur) {
      this.props.onBlur(date, ev)
    }
  }

  _onChangeInput (e) {
    const value = e.target.value
    this.setState({ value: value })
    const maskFormat = DateUtil.getDisplayInputFormat()
    const splitter = maskFormat === '99-99-9999' ? '-' : '/'
    const values = value.split(splitter)

    if (
      values &&
      values.length === 3 &&
      values[2] &&
      (values[2].length > 3 ||
        (maskFormat === '99/99/99' && values[2].length > 1))
    ) {
      let day = values[0] < 31 ? values[0] : 31
      let month = values[1] < 12 ? values[1] : 12
      let year = values[2]

      if (maskFormat === '99/99/99') {
        day = values[1] < 31 ? values[1] : 31
        month = values[0] < 12 ? values[0] : 12
        year = `20${values[2]}`
      }

      const date = DateUtil.getUTCDateFromDate(new Date(year, month - 1, day))

      if (this.props.onChange) {
        this.props.onChange(date)
      }
    } else if (!value) {
      if (this.props.onChange) {
        this.props.onChange(null)
      }
    }
  }

  _handleSelect (val) {
    this.setState({ active: false, bLabel: true })
    if ((!val || (val && typeof val !== 'string')) && this.props.onChange) {
      const date = val ? DateUtil.getUTCDateFromDate(val._d) : null
      this.props.onChange(date)
    }
  }

  _onShowDatepicker (event) {
    event.preventDefault()
    if (this._references.datepicker.current) {
      this._references.datepicker.current.openCalendar()
    }
  }

  _onNavigateMonth (year, month) {
    if (this.props.onNavigateMonth) {
      this.props.onNavigateMonth(year, month, weekStats => {
        this.data.weekStats = weekStats || []
        if (this._references.datepicker.current) {
          this._references.datepicker.current.refresh()
        }
      })
    }
  }

  _renderDay (props, currentDate, _selectedDate) {
    if (this.props.formatDay) {
      const weekNo = DateUtil.getDisplayWeek(currentDate)
      const weekObj = _.find(this.data.weekStats, obj => obj.weekNo === weekNo)
      let className = ''

      if (weekObj && weekObj.percentage !== null) {
        if (weekObj.percentage >= 100) {
          className = ' success'
        } else if (weekObj.percentage <= 0) {
          className = ' error'
        } else {
          className = ' warning'
        }

        props.className = `${props.className}${className}`
      }
    }

    return <td {...props}>{currentDate.date()}</td>
  }

  _renderWeek (props, weekNo) {
    if (this.props.formatDay) {
      const weekObj = _.find(this.data.weekStats, obj => obj.weekNo === weekNo)
      let className = ''

      if (weekObj && weekObj.percentage !== null) {
        if (weekObj.percentage >= 100) {
          className = ' success'
        } else if (weekObj.percentage <= 0) {
          className = ' error'
        } else {
          className = ' warning'
        }

        props.className = `${props.className}${className}`
      }
    }

    return <td {...props}>{weekNo}</td>
  }
}

export default FormDatePicker
